module.exports = __webpack_public_path__ + "img/pen-and-rubber-active.65cb70f1.png";